var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEVandChargingEquipment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 1C18.16 1 18.72 1.42 18.92 2.01L21 8V16C21 16.55 20.55 17 20 17H19C18.45 17 18 16.55 18 16V15H6V16C6 16.55 5.55 17 5 17H4C3.45 17 3 16.55 3 16V8L5.08 2.01C5.29 1.42 5.84 1 6.5 1H17.5ZM5 10.5C5 11.33 5.67 12 6.5 12C7.33 12 8 11.33 8 10.5C8 9.67 7.33 9 6.5 9C5.67 9 5 9.67 5 10.5ZM16 10.5C16 11.33 16.67 12 17.5 12C18.33 12 19 11.33 19 10.5C19 9.67 18.33 9 17.5 9C16.67 9 16 9.67 16 10.5ZM6.5 2.5L5 7H19L17.5 2.5H6.5ZM11 20H7L13 23V21H17L11 18V20Z",
    fill: "#273137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 1C18.16 1 18.72 1.42 18.92 2.01L21 8V16C21 16.55 20.55 17 20 17H19C18.45 17 18 16.55 18 16V15H6V16C6 16.55 5.55 17 5 17H4C3.45 17 3 16.55 3 16V8L5.08 2.01C5.29 1.42 5.84 1 6.5 1H17.5ZM5 10.5C5 11.33 5.67 12 6.5 12C7.33 12 8 11.33 8 10.5C8 9.67 7.33 9 6.5 9C5.67 9 5 9.67 5 10.5ZM16 10.5C16 11.33 16.67 12 17.5 12C18.33 12 19 11.33 19 10.5C19 9.67 18.33 9 17.5 9C16.67 9 16 9.67 16 10.5ZM6.5 2.5L5 7H19L17.5 2.5H6.5ZM11 20H7L13 23V21H17L11 18V20Z",
    fill: "white",
    fillOpacity: 0.75
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEVandChargingEquipment1);
export default __webpack_public_path__ + "static/media/EV and Charging Equipment-1.01f01538b10db1c9177b40f4b654baae.svg";
export { ForwardRef as ReactComponent };